import { createActions, createState, createReducer } from 'reduxsauce-crud'

export const CenterOptionsRedux = createActions({},
  {
    prefix: 'CENTER_OPTIONS_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = CenterOptionsRedux
export const CenterOptionsTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

export const reducer = createReducer(INITIAL_STATE, {},
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/CenterOptionsRedux.js